import { Skill } from 'types/Skill';

type Dto = {
  __typename?: 'PreferencesSkillType';
  tagId: string;
  weight: number;
};

export const mapSkills = (dtoSkills: Dto[]): Skill[] =>
  dtoSkills.map((dto) => ({
    tagId: dto.tagId,
    weight: dto.weight,
  }));
